import { useNavigate, useLocation } from 'react-router-dom';
import { useState, useEffect, useMemo } from 'react';
import { GridIcon, FolderIcon, TrashIcon } from '../../icons';
import NavItem from '../Nav/NavItem';

const DashboardNav = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const [activeItem, setActiveItem] = useState('dashboard');

    // Dashboard menu items
    const menuItems = useMemo(() => [
        {
            id: 'explore',
            label: 'Explore',
            icon: GridIcon,
            route: '/my/items',
        },
        {
            id: 'folders',
            label: 'Folders',
            icon: FolderIcon,
            route: '/my',
        },
        {
            id: 'trash',
            label: 'Trash Bin',
            icon: TrashIcon,
            route: '/my/trash',
        },
  ], []);

    // Sync active item with current route
    useEffect(() => {
        const currentItem = menuItems.find(item => 
            item.route === location.pathname
        );
        
        if (currentItem) {
            setActiveItem(currentItem.id);
        }

    }, [location.pathname, menuItems]);

    const handleItemClick = (item) => {
        setActiveItem(item.id);
        if (item.route) {
            navigate(item.route);
        }
    };

    return (
        <div className="flex flex-col gap-1">
            {menuItems.map((item) => (
                <NavItem
                    key={item.id}
                    icon={item.icon}
                    label={item.label}
                    isActive={activeItem === item.id}
                    onClick={() => handleItemClick(item)}
                />
            ))}
        </div>
    );
};

export default DashboardNav;